import React, { useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import PredictiveQuizContainer from "./PredictiveQuizContainer";
import PredictiveResults from "./PredictiveResults";
import UserInfoForm, { UserInfo } from "../../components/UserInfoForm";
import { PredictiveScores } from "./questions";
import { webhookService } from "../../shared/webhookService";

export interface PredictiveResult {
  questionId: number;
  question: string;
  answer: string;
  scores: PredictiveScores;
}

const PredictiveQuiz: React.FC = () => {
  const [results, setResults] = useState<PredictiveResult[]>([]);
  const [showQuiz, setShowQuiz] = useState(false);
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);
  const navigate = useNavigate();

  const handleUserInfoSubmit = (userData: UserInfo) => {
    setUserInfo(userData);
    setShowQuiz(true);
  };

  const handleQuizComplete = async (quizResults: PredictiveResult[]) => {
    setResults(quizResults);

    // Prepare webhook data
    const webhookData = {
      quizName: "Predictive Quiz",
      userInfo: userInfo || {},
      responses: quizResults.map((result, index) => ({
        questionNumber: index + 1,
        question: result.question,
        answer: result.answer,
      })),
      timestamp: new Date().toISOString(),
    };

    // Send to webhook (with automatic retry on failure)
    await webhookService.submitQuizData(webhookData);

    navigate("results", { replace: true });
  };

  const handleRestart = () => {
    setResults([]);
    setShowQuiz(false);
    setUserInfo(null);
    navigate(".", { replace: true });
  };

  return (
    <div>
      <Routes>
        <Route
          path="/"
          element={
            showQuiz ? (
              <PredictiveQuizContainer onQuizComplete={handleQuizComplete} />
            ) : (
              <UserInfoForm
                onSubmit={handleUserInfoSubmit}
                subtitle="Unlock Your Data's Predictive Power"
              />
            )
          }
        />
        <Route
          path="results"
          element={
            <PredictiveResults results={results} onRestart={handleRestart} />
          }
        />
      </Routes>
    </div>
  );
};

export default PredictiveQuiz;
